var _defs, _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDematic = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  xmlSpace: "preserve",
  viewBox: "0 0 26 26"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "Dematic_svg__a",
  d: "M0 0h26v26H0z"
}))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
  id: "Dematic_svg__b"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#Dematic_svg__a",
  overflow: "visible"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#FFF",
  clipPath: "url(#Dematic_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.8 13.9v2.5h.7s.4 0 .6-.1.5-.3.5-1.1-.2-1-.6-1.2c-.2-.1-.6-.1-.6-.1zm-.6-.5h1.6s.5 0 .8.3c.3.2.6.6.6 1.5 0 .8-.4 1.3-.7 1.5s-.7.2-.9.2H5.2zM8.6 13.4h2.5v.5H9.2v.9H11v.5H9.2v1h1.9v.5H8.6zm3 0h.8l.9 2.7.9-2.7h.8v3.5h-.6v-2.7l-.9 2.7H13l-1-2.7v2.7h-.6v-3.5zm5.9 2.1L17 14l-.5 1.5zm-.8-2.1h.6l1.3 3.5H18l-.3-.9h-1.4l-.3.9h-.6zm1.5 0H21v.5h-1.1v3h-.6v-3h-1.1zm3.2 0h.6v3.5h-.6zm3.8.9c-.1-.2-.3-.3-.6-.4s-.7-.1-1 .2-.4.6-.4 1c0 .3.1.9.3 1.1s.5.3.8.3c.2 0 .5-.1.7-.3l.2-.2.4.3-.3.3c-.2.2-.6.3-1 .3-.5 0-.8-.1-1.1-.4s-.6-.8-.5-1.4c0-.6.3-1.1.5-1.3.3-.2.6-.4 1.1-.4s.8.1 1 .3c.1.1.3.2.4.4zM.4 7.9h1.2V17H.4z"
}))));
export default SvgDematic;